export default __webpack_public_path__ + "static/media/HeartBeat.4a8cda4f.svg";